import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { canUseFirebaseMessaging, requestNotificationPermission } from './firebase';

// FCM's service worker calls firebase.messaging() at load. On iPhone Safari
// that throws messaging/unsupported-browser, so only register where push works.
canUseFirebaseMessaging().then((supported) => {
  if (!supported || !('serviceWorker' in navigator)) return;

  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);

      requestNotificationPermission()
        .then((token) => {
          console.log('Notification permission granted, token:', token);
        })
        .catch((err) => {
          console.error('Failed to get notification permission:', err);
        });
    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
